export enum InternationalType {
  Domestic = 'Domestic',
  International = 'International',
  InternationalDuty = 'InternationalDuty',
}
